import React, { Component } from 'react'
import { navigate } from '@reach/router'
import { Brand, Form } from 'components'
import { UserApi } from 'api'
import AppStore from 'AppStore'
import Axios from 'axios'

import readingIllustration from 'assets/brand/reading-illustration.svg'

interface Props {
  path: string
}
//discord

interface State {
  email?: string
  password?: string
  wrongCredentials: boolean
}

export default class LoginPage extends Component<Props, State> {
  onSubmit = async () => {
    const email = this.state.email
    const password = this.state.password

    try {
      const user = await UserApi.login(email!, password!)
      if (user.type && user.type > 2) {
        this.setState({ wrongCredentials: true })
        return
      }
      if (user) {
        AppStore.saveUser(user).then(async () => {
          const redirectUrl = AppStore.redirectUrl
          Axios.defaults.headers.common['accesstoken'] = AppStore.user?.accessToken
          Axios.defaults.headers.common['appversion'] = '2.0.11'

          await AppStore.saveRedirectUrl('/')
          await AppStore.changeNotification({ message: 'Login effettuato correttamente', type: 'success' })
          navigate(redirectUrl ?? '/')
        })
      } else {
        console.log('fail')
      }
    } catch (error) {
      console.log(error)
      this.setState({ wrongCredentials: true })
    }
  }

  state: State = { wrongCredentials: false }

  render() {
    const { wrongCredentials } = this.state
    return (
      <main className="sq-login">
        <div className="sq-login__layout">
          <section className="sq-login__story" aria-label="Special Quiz">
            <div className="sq-login__brand"><Brand subtitle="Gestionale autori" /></div>
            <h1>Contenuti accurati, pronti per chi studia.</h1>
            <p>Gestisci domande, revisioni e catalogo con lo stesso linguaggio visivo dell'app Special Quiz.</p>
            <img className="sq-login__illustration" src={readingIllustration} alt="Studente che legge" />
          </section>
          <section className="sq-login__card" aria-labelledby="login-title">
            <div className="sq-login__mobile-brand"><Brand subtitle="Gestionale autori" /></div>
            <h2 id="login-title">Bentornato</h2>
            <p>Accedi al portale autori.</p>
            <Form
              onSubmit={this.onSubmit}
              values={this.state}
              onValuesChange={(state) => this.setState({ ...state })}
              fields={[
                [{ key: 'email', type: 'TEXT', label: 'Email', required: true, placeHolder: 'nome@specialquiz.it' }],
                [{ key: 'password', type: 'TEXT', textType: 'password', label: 'Password', required: true }],
              ]}
              submitText="Accedi"
              submitStyle={{ marginTop: 16, width: '100%' }}
            />
            {wrongCredentials && <div className="sq-login__error" role="alert">Email o password errati</div>}
          </section>
        </div>
      </main>
    )
  }
}
